import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import { useWaveById } from "@/hooks/useWaveById";
import { getTimeAgoShort, numberWithCommas } from "@/helpers/Helpers";
import WavePicture from "@/components/waves/WavePicture";
interface WaveProfileTooltipProps {
  readonly waveId: string;
  readonly initialWave?: ApiWaveMin | null;
  readonly fallbackName?: string | undefined;
}
const formatNumber = (value?: number | null) => typeof value === "number" ? numberWithCommas(value) : "--";
export default function WaveProfileTooltip(t0) {
  const $ = _c(27);
  const {
    waveId,
    initialWave: t1,
    fallbackName
  } = t0;
  const initialWave = t1 === undefined ? null : t1;
  const {
    wave
  } = useWaveById(waveId);
  const waveName = wave?.name ?? initialWave?.name ?? fallbackName ?? `Wave ${waveId}`;
  const wavePicture = wave?.picture ?? initialWave?.picture ?? null;
  const authorHandle = wave?.author.handle ?? wave?.author.primary_address ?? null;
  wave?.contributors_overview;
  let t2;
  if ($[0] !== wave?.contributors_overview) {
    t2 = wave?.contributors_overview.map(_temp).filter(_temp2) ?? [];
    $[0] = wave?.contributors_overview;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const contributors = t2;
  const dropsCount = wave?.metrics.drops_count;
  const subscribersCount = wave?.metrics.subscribers_count;
  const latestDropTimestamp = wave?.metrics.latest_drop_timestamp;
  const statsReady = Boolean(wave?.metrics);
  const hasDrops = typeof dropsCount === "number" && dropsCount > 0;
  let t3;
  if ($[2] !== hasDrops || $[3] !== latestDropTimestamp) {
    t3 = hasDrops && typeof latestDropTimestamp === "number" ? `Last drop ${getTimeAgoShort(latestDropTimestamp)}` : "No drops yet";
    $[2] = hasDrops;
    $[3] = latestDropTimestamp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const lastDropLabel = t3;
  let t4;
  if ($[5] !== contributors || $[6] !== waveName || $[7] !== wavePicture) {
    t4 = <div className="tw-h-10 tw-w-10 tw-flex-shrink-0"><WavePicture name={waveName} picture={wavePicture} contributors={contributors} /></div>;
    $[5] = contributors;
    $[6] = waveName;
    $[7] = wavePicture;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== waveName) {
    t5 = <span className="tw-truncate tw-text-sm tw-font-semibold tw-text-iron-50">{waveName}</span>;
    $[9] = waveName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== authorHandle) {
    t6 = authorHandle && <span className="tw-truncate tw-text-xs tw-text-iron-400">@{authorHandle}</span>;
    $[11] = authorHandle;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <div className="tw-flex tw-items-start tw-gap-3">{t4}{t7}</div>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== dropsCount || $[20] !== lastDropLabel || $[21] !== statsReady || $[22] !== subscribersCount) {
    t9 = <div className="tw-mt-3">{statsReady ? <><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-1 tw-text-xs tw-text-iron-400"><span className="tw-inline-flex tw-items-center tw-gap-1"><span className="tw-font-medium tw-text-iron-100">{formatNumber(dropsCount)}</span><span className="tw-text-iron-500">{dropsCount === 1 ? "Drop" : "Drops"}</span></span><span className="tw-inline-flex tw-items-center tw-gap-1"><span className="tw-font-medium tw-text-iron-100">{formatNumber(subscribersCount)}</span><span className="tw-text-iron-500">Joined</span></span></div><div className="tw-mt-2 tw-text-[11px] tw-text-iron-500">{lastDropLabel}</div></> : <div className="tw-h-4 tw-w-40 tw-animate-pulse tw-rounded tw-bg-iron-800/60" />}</div>;
    $[19] = dropsCount;
    $[20] = lastDropLabel;
    $[21] = statsReady;
    $[22] = subscribersCount;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div className="tailwind-scope tw-min-w-[260px] tw-max-w-[320px] tw-bg-iron-950 tw-p-4">{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp2(contributor_0) {
  return !!contributor_0.pfp;
}
function _temp(contributor) {
  return {
    pfp: contributor.contributor_pfp,
    identity: contributor.contributor_identity
  };
}